import { useQuery } from 'react-query';
import { createClient } from 'contentful';

export default function getContentfulClient() {
  return createClient({
    space: '6l54i7r34vme',
    environment: 'master', // defaults to 'master' if not set
    accessToken: '9x49NwjT24akScYuRcEdY69Sb0_ySR1zS1x3wvqNKNk'
  });
}

export function useNoticePostsQuery() {
  const client = getContentfulClient();
  const { data: noticePosts } = useQuery(
    ['noticePosts'],
    () =>
      client.withoutLinkResolution.withoutUnresolvableLinks.getEntries({
        content_type: 'notice-posts'
      }),
    {
      select: (data) => data.items
    }
  );
  return noticePosts;
}

export async function getNoticePosts() {
  const client = getContentfulClient();
  const response = await client.withoutLinkResolution.withoutUnresolvableLinks.getEntries({
    content_type: 'notice-posts'
  });
  return response.items;
}

export async function getLatestNoticePost() {
  const client = getContentfulClient();
  const response = await client.withoutLinkResolution.withoutUnresolvableLinks.getEntries({
    content_type: 'notice-posts',
    limit: 1,
    order: '-fields.authoredAt,-sys.createdAt'
  });
  return response.items?.[0] ?? null;
}

export function useLatestNoticePostQuery() {
  const client = getContentfulClient();
  return useQuery(
    ['noticePosts', 'latest'],
    () =>
      client.withoutLinkResolution.withoutUnresolvableLinks.getEntries({
        content_type: 'notice-posts',
        limit: 1,
        order: '-fields.authoredAt,-sys.createdAt'
      }),
    {
      select: (res) => res.items?.[0] ?? null
    }
  );
}
